// extracted by mini-css-extract-plugin
export default {"root":"_1JdLH","imageWrapper":"_3AFpL","image":"_3um_O","placeholder":"_3422L","title":"eh2WB","subtitle":"_32nH3"};